export default "__VITE_PUBLIC_ASSET__ba293330__"